import React from 'react';
import { useLanguage } from '../contexts/LanguageContext';
import {
  Box,
  Button,
  Menu,
  MenuItem,
  ListItemIcon,
  ListItemText,
  Typography,
} from '@mui/material';
import LanguageIcon from '@mui/icons-material/Language';
import FlagIcon from '@mui/icons-material/Flag';

const LanguageSwitcher = () => {
  const { language, changeLanguage, t } = useLanguage();
  const [anchorEl, setAnchorEl] = React.useState(null);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleLanguageChange = (newLanguage) => {
    changeLanguage(newLanguage);
    handleClose();
  };

  const languageOptions = {
    en: { flag: '🇺🇸', name: 'English' },
    es: { flag: '🇪🇸', name: 'Español' },
    pt: { flag: '🇧🇷', name: 'Português' },
  };

  return (
    <Box>
      <Button
        variant="outlined"
        size="small"
        startIcon={<LanguageIcon />}
        onClick={handleClick}
      >
        {languageOptions[language]?.flag} {languageOptions[language]?.name}
      </Button>
      <Menu
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={handleClose}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'right',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'right',
        }}
      >
        {Object.entries(languageOptions).map(([code, { flag, name }]) => (
          <MenuItem
            key={code}
            onClick={() => handleLanguageChange(code)}
            selected={code === language}
          >
            <ListItemIcon>
              <FlagIcon /> {flag}
            </ListItemIcon>
            <ListItemText>
              <Typography variant="body2">{name}</Typography>
            </ListItemText>
          </MenuItem>
        ))}
      </Menu>
    </Box>
  );
};

export default LanguageSwitcher;
